export enum PlanListInteractions {
  PageReady = 'page_ready',
  NavigateToList = 'navigate_to_list',
}
